import React, { Component, useEffect, useState } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";

import TopButton from "../../components/topButton/TopButton";

import "./Projects.css";
import ProjectCard from "../../components/projectCard/ProjectCard"; // Importar el nuevo componente


const Projects = (props) => {
  const [projects, setProjects] = useState([]);
  const theme = props.theme;

  useEffect(() => {
    fetch("https://mikalet.com/api/portfolio/proyectos.php") // URL de la API en XAMPP
      .then((response) => response.json())
      .then((data) => setProjects(data))
      .catch((error) => console.error("Error al obtener proyectos:", error));
  }, []);

  return (
    <div className="projects-main">
      <Header theme={theme} />
      <div className="repo-cards-div-main">
        {projects.map((repo) => {
                return <ProjectCard repo={repo} theme={theme} />; // Usar el nuevo componente

        })}
      </div>
      
      <Footer theme={props.theme} onToggle={props.onToggle} />
      <TopButton theme={props.theme} />
    </div>
  );
};

export default Projects;